<!-- Subscription Warning Banner -->
<div *ngIf="warningData && !isLoading" class="subscription-warning-banner" [class]="getWarningClass()">

    <div class="flex items-center justify-between p-4 border ">
        <!-- Warning Icon and Message -->
        <div class="flex items-center space-x-3">
            <!-- Warning Icon -->
            <div class="flex-shrink-0">
                <!-- Clock icon for trialing -->
                <svg *ngIf="warningData.stripeStatus === 'trialing'" class="w-6 h-6"
                    [class]="getIconClass()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z">
                    </path>
                </svg>
                <!-- Warning icon for incomplete -->
                <svg *ngIf="warningData.stripeStatus === 'incomplete'" class="w-6 h-6"
                    [class]="getIconClass()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z">
                    </path>
                </svg>
                <!-- Exclamation icon for past_due, unpaid -->
                <svg *ngIf="warningData.stripeStatus === 'past_due' || warningData.stripeStatus === 'unpaid'" class="w-6 h-6"
                    [class]="getIconClass()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                    </path>
                </svg>
                <!-- Warning icon for paused -->
                <svg *ngIf="warningData.stripeStatus === 'paused'" class="w-6 h-6"
                    [class]="getIconClass()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z">
                    </path>
                </svg>
                <!-- Exclamation icon for not_found -->
                <svg *ngIf="warningData.stripeStatus === 'not_found'" class="w-6 h-6"
                    [class]="getIconClass()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                    </path>
                </svg>
            </div>

            <!-- Warning Message -->
            <div class="flex-1">
                <p class="text-sm font-medium">
                    {{ getWarningMessage() }}
                </p>
                <p *ngIf="!warningData.isExpired && warningData.stripeStatus === 'trialing'" class="text-xs opacity-75 mt-1">
                    {{ warningData.isTrial ? 'Trial ends' : 'Expires' }} on {{ warningData.subscriptionEndDate | date:'dd MMM yyyy' }}
                </p>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex items-center space-x-2 ml-4" *ngIf="isOwner">
            <!-- Renew/Renewal Button -->
            <button mat-button [class]="getButtonClass()"
                class="px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200"
                (click)="onRenewSubscription()">
                <!-- <mat-icon class="w-4 h-4 mr-1 text-white">{{ getButtonIcon() }}</mat-icon> -->
                {{ getButtonText() }}
            </button>

            <!-- Dismiss Button -->
            <!-- <button mat-icon-button class="text-gray-500 hover:text-gray-700 transition-colors duration-200"
                (click)="onDismiss()" matTooltip="Dismiss warning">
                <mat-icon class="w-5 h-5">close</mat-icon>
            </button> -->
        </div>
    </div>
</div>

<!-- Loading State -->
<!-- <div *ngIf="isLoading" class="subscription-warning-banner bg-gray-50 border border-gray-200">
    <div class="flex items-center justify-center p-4">
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600"></div>
        <span class="ml-2 text-sm text-gray-600">Checking subscription status...</span>
    </div>
</div> -->